import { assign, number, object } from "superstruct";

import BaseGiftRegistrantSchema from "./BaseGiftRegistrantSchema";

const GiftRegistrantSchema = assign(
    BaseGiftRegistrantSchema,
    object({
        id: number(),
    })
);

export default GiftRegistrantSchema;
